"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = RetirementIncomeGapPageTwo;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _RetirementIncomeGapFormControls = require("./RetirementIncomeGapFormControls");
var _utils = require("../../middleware/utils");
var _RetirementIncomeGapHousingModal = _interopRequireDefault(require("./RetirementIncomeGapHousingModal"));
var _RetirementIncomeGapGroceriesModal = _interopRequireDefault(require("./RetirementIncomeGapGroceriesModal"));
var _RetirementIncomeGapTravelModal = _interopRequireDefault(require("./RetirementIncomeGapTravelModal"));
var _RetirementIncomeGapPersonalModal = _interopRequireDefault(require("./RetirementIncomeGapPersonalModal"));
var _RetirementIncomeGapTransportationModal = _interopRequireDefault(require("./RetirementIncomeGapTransportationModal"));
var _RetirementIncomeGapHealthcareModal = _interopRequireDefault(require("./RetirementIncomeGapHealthcareModal"));
var _RetirementIncomeGapWizardCalc = require("./RetirementIncomeGapWizardCalc.config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function RetirementIncomeGapPageTwo(_ref) {
  var {
    setValidationData,
    setCurrentExpenses,
    apiData
  } = _ref;
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = (0, _formik.useFormikContext)();
  var [showHousingModal, setShowHousingModal] = (0, _react.useState)(false);
  var [showHealthcareModal, setShowHealthcareModal] = (0, _react.useState)(false);
  var [showTransportationModal, setShowTransportationModal] = (0, _react.useState)(false);
  var [showGroceriesModal, setShowGroceriesModal] = (0, _react.useState)(false);
  var [showTravelModal, setShowTravelModal] = (0, _react.useState)(false);
  var [showPersonalModal, setShowPersonalModal] = (0, _react.useState)(false);
  var [snapshot, setSnapshot] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    if (!values.apiHasBeenCalled) {
      Object.keys(apiData).forEach(key => {
        if (key === 'socialSecurityBenefit') {
          setFieldValue(key, (0, _utils.numberToString)(apiData[key]));
        } else {
          setFieldValue(key, (0, _utils.numberToCurrencyString)((apiData[key] - 1) * 100, 2, false));
        }
      });
    }
    document.getElementById(_RetirementIncomeGapWizardCalc.calcName).scrollIntoView();
    /* istanbul ignore else*/
    if (window) {
      window.scrollBy(0, -112);
    }
    setFieldValue('apiHasBeenCalled', true);
  }, []);
  var sumModalValues = expenses => {
    var sum = 0;
    for (var e in expenses) {
      sum += (0, _utils.parseCurrencyString)(null, expenses[e]);
    }
    return sum;
  };
  (0, _react.useEffect)(() => {
    if (values.housing_modalHasBeenOpened === false) {
      setFieldValue('housing_otherExpenses', values.housingAndInsuranceCost || '0');
    }
    if (values.healthcare_modalHasBeenOpened === false) {
      setFieldValue('healthcare_otherExpenses', values.healthcareAndInsuranceCost || '0');
    }
    if (values.transportation_modalHasBeenOpened === false) {
      setFieldValue('transportation_otherExpenses', values.transportationAndInsuranceCost || '0');
    }
    if (values.groceries_modalHasOpened === false) {
      setFieldValue('groceries_otherFoodExpenses', values.groceriesAndDiningOutCost || '0');
    }
    if (values.travel_modalHasBeenOpened === false) {
      setFieldValue('travel_otherTravelEntertainmentExpenses', values.travelAndEntertainmentCost || '0');
    }
    if (values.personal_modalHasBeenOpened === false) {
      setFieldValue('personal_otherPersonalExpenses', values.personalAndMiscellaneousCost || '0');
    }
    setCurrentExpenses(sumCurrentExpenses());
    if (!values.touched_future_housingAndInsuranceCost) {
      setFieldValue('future_housingAndInsuranceCost', values.housingAndInsuranceCost);
    }
    if (!values.touched_future_healthcareAndInsuranceCost) {
      setFieldValue('future_healthcareAndInsuranceCost', values.healthcareAndInsuranceCost);
    }
    if (!values.touched_future_transportationAndInsuranceCost) {
      setFieldValue('future_transportationAndInsuranceCost', values.transportationAndInsuranceCost);
    }
    if (!values.touched_future_groceriesAndDiningOutCost) {
      setFieldValue('future_groceriesAndDiningOutCost', values.groceriesAndDiningOutCost);
    }
    if (!values.touched_future_travelAndEntertainmentCost) {
      setFieldValue('future_travelAndEntertainmentCost', values.travelAndEntertainmentCost);
    }
    if (!values.touched_future_personalAndMiscellaneousCost) {
      setFieldValue('future_personalAndMiscellaneousCost', values.personalAndMiscellaneousCost);
    }
  }, [values.housingAndInsuranceCost, values.healthcareAndInsuranceCost, values.transportationAndInsuranceCost, values.groceriesAndDiningOutCost, values.travelAndEntertainmentCost, values.personalAndMiscellaneousCost]);

  // -- Housing Modal Handlers --
  var housingHandleClose = () => {
    setValidationData(null);
    setShowHousingModal(false);
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  var housingHandleSubmit = () => {
    var modalFields = [values.housing_mortgageRentCost, values.housing_realEstateTaxes, values.housing_utilitiesLawnMaintenance, values.housing_applianceFurnishings, values.housing_homeownersInsurance, values.housing_hoaFees, values.housing_otherExpenses];
    var total = sumModalValues(modalFields);
    setFieldValue('housingAndInsuranceCost', (0, _utils.numberToString)(total));
    setValidationData(null);
    setShowHousingModal(false);
  };
  var housingHandleShow = () => {
    (0, _utils.customTealiumEvent)(_RetirementIncomeGapWizardCalc.calcName, 'click', 'itemizeHousingExpenses');
    setValidationData(_RetirementIncomeGapWizardCalc.validationHousingModal);
    setShowHousingModal(true);
    setSnapshot(values);
  };

  //event handlers for healthcare modal
  var healthcareHandleClose = () => {
    setValidationData(null);
    setShowHealthcareModal(false);
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  var healthcareHandleSubmit = () => {
    var modalFields = [values.healthcare_insurancePremium, values.healthcare_medicalServices, values.healthcare_homeHealthCare, values.healthcare_prescriptions, values.healthcare_medicalSupplies, values.healthcare_vitaminsMedicines, values.healthcare_outOfPocketServices, values.healthcare_fitnessGym, values.healthcare_lifeInsurancePremiums, values.healthcare_longTermCarePremiums, values.healthcare_disabilityInsurancePremiums, values.healthcare_otherExpenses];
    var total = sumModalValues(modalFields);
    setFieldValue('healthcareAndInsuranceCost', (0, _utils.numberToString)(total));
    setValidationData(null);
    setShowHealthcareModal(false);
  };
  var healthcareHandleShow = () => {
    (0, _utils.customTealiumEvent)(_RetirementIncomeGapWizardCalc.calcName, 'click', 'itemizeHealthcareExpenses');
    setValidationData(_RetirementIncomeGapWizardCalc.validationHealthcareModal);
    setShowHealthcareModal(true);
    setSnapshot(values);
  };
  //event handlers for transportation modal
  var transportationHandleClose = () => {
    setValidationData(null);
    setShowTransportationModal(false);
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  var transportationHandleSubmit = () => {
    var modalFields = [values.transportation_automobilePayments, values.transportation_carInsurance, values.transportation_carMaintenance, values.transportation_transport, values.transportation_gas, values.transportation_otherExpenses];
    var total = sumModalValues(modalFields);
    setFieldValue('transportationAndInsuranceCost', (0, _utils.numberToString)(total));
    setValidationData(null);
    setShowTransportationModal(false);
  };
  var transportationHandleShow = () => {
    (0, _utils.customTealiumEvent)(_RetirementIncomeGapWizardCalc.calcName, 'click', 'itemizeTransportationExpenses');
    setValidationData(_RetirementIncomeGapWizardCalc.validationTransportationModal);
    setShowTransportationModal(true);
    setSnapshot(values);
  };

  // -- Groceries Modal Handlers --
  var groceriesHandleClose = () => {
    setValidationData(null);
    setShowGroceriesModal(false);
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  var groceriesHandleSubmit = () => {
    var modalFields = [values.groceries_groceries, values.groceries_diningOut, values.groceries_subscriptionFoodServices, values.groceries_takeOutDelivery, values.groceries_otherFoodExpenses];
    var total = sumModalValues(modalFields);
    setFieldValue('groceriesAndDiningOutCost', (0, _utils.numberToString)(total));
    setValidationData(null);
    setShowGroceriesModal(false);
  };
  var groceriesHandleShow = () => {
    (0, _utils.customTealiumEvent)(_RetirementIncomeGapWizardCalc.calcName, 'click', 'itemizeGroceriesExpenses');
    setValidationData(_RetirementIncomeGapWizardCalc.validationGroceriesModal);
    setShowGroceriesModal(true);
    setSnapshot(values);
  };

  // -- Travel & Entertainment Modal Handlers --
  var travelHandleClose = () => {
    setValidationData(null);
    setShowTravelModal(false);
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  var travelHandleSubmit = () => {
    var modalFields = [values.travel_activitiesClubsMemberships, values.travel_moviesShowsEntertainment, values.travel_vacation, values.travel_hotelStays, values.travel_roadTrips, values.travel_otherTravelEntertainmentExpenses];
    var total = sumModalValues(modalFields);
    setFieldValue('travelAndEntertainmentCost', (0, _utils.numberToString)(total));
    setValidationData(null);
    setShowTravelModal(false);
  };
  var travelHandleShow = () => {
    (0, _utils.customTealiumEvent)(_RetirementIncomeGapWizardCalc.calcName, 'click', 'itemizeTravel&EntertainmentExpenses');
    setValidationData(_RetirementIncomeGapWizardCalc.validationTravelModal);
    setShowTravelModal(true);
    setSnapshot(values);
  };

  // -- Personal & Miscellaneous Modal Handlers --
  var personalHandleClose = () => {
    setValidationData(null);
    setShowPersonalModal(false);
    for (var property in snapshot) {
      setFieldValue(property, snapshot[property], false);
    }
  };
  var personalHandleSubmit = () => {
    var modalFields = [values.personal_clothing, values.personal_personalCare, values.personal_creditCards, values.personal_fixedLoans, values.personal_giftsToOthers, values.personal_petCare, values.personal_otherPersonalExpenses];
    var total = sumModalValues(modalFields);
    setFieldValue('personalAndMiscellaneousCost', (0, _utils.numberToString)(total));
    setValidationData(null);
    setShowPersonalModal(false);
  };
  var personalHandleShow = () => {
    (0, _utils.customTealiumEvent)(_RetirementIncomeGapWizardCalc.calcName, 'click', 'itemizePersonal&MiscExpenses');
    setValidationData(_RetirementIncomeGapWizardCalc.validationPersonalModal);
    setShowPersonalModal(true);
    setSnapshot(values);
  };
  function sumCurrentExpenses() {
    return 0 + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.housingAndInsuranceCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.healthcareAndInsuranceCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.transportationAndInsuranceCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.groceriesAndDiningOutCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.travelAndEntertainmentCost)) + (0, _utils.ifNanReturn0)((0, _utils.parseCurrencyString)(null, values.personalAndMiscellaneousCost));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.HousingAndInsurance, {
    errors: errors,
    touched: touched,
    values: values,
    onClick: housingHandleShow
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.HealthcareAndInsurance, {
    errors: errors,
    touched: touched,
    values: values,
    onClick: healthcareHandleShow
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.TransportationAndInsurance, {
    errors: errors,
    touched: touched,
    values: values,
    onClick: transportationHandleShow
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.GroceriesAndDiningOut, {
    errors: errors,
    touched: touched,
    values: values,
    onClick: groceriesHandleShow
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.TravelAndEntertainment, {
    errors: errors,
    touched: touched,
    values: values,
    onClick: travelHandleShow
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapFormControls.PersonalAndMiscellaneous, {
    errors: errors,
    touched: touched,
    values: values,
    onClick: personalHandleShow
  })), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapHousingModal.default, {
    show: showHousingModal,
    handleClose: housingHandleClose,
    snapshot: snapshot,
    housingHandleSubmit: housingHandleSubmit
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapHealthcareModal.default, {
    show: showHealthcareModal,
    handleClose: healthcareHandleClose,
    snapshot: snapshot,
    healthcareHandleSubmit: healthcareHandleSubmit
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapTransportationModal.default, {
    show: showTransportationModal,
    handleClose: transportationHandleClose,
    snapshot: snapshot,
    transportationHandleSubmit: transportationHandleSubmit
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapGroceriesModal.default, {
    show: showGroceriesModal,
    handleClose: groceriesHandleClose,
    snapshot: snapshot,
    groceriesHandleSubmit: groceriesHandleSubmit
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapTravelModal.default, {
    show: showTravelModal,
    handleClose: travelHandleClose,
    snapshot: snapshot,
    travelHandleSubmit: travelHandleSubmit
  }), /*#__PURE__*/_react.default.createElement(_RetirementIncomeGapPersonalModal.default, {
    show: showPersonalModal,
    handleClose: personalHandleClose,
    snapshot: snapshot,
    personalHandleSubmit: personalHandleSubmit
  }));
}